module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    ref: "example",
    staticClass: "example",
    attrs: {
      "data-clipboard-text": _vm.varName
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ebe4b0ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/Example.vue
// module id = 1468
// module chunks = 1